import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
export function ComingSoon() {
  return <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-132" data-mp="4c54nwlhmkgh">
      <SiteHeader data-id="element-133" data-mp="3vftsbcgxebho" />
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col justify-center px-6 py-24 lg:px-10" data-id="element-134" data-mp="3vfab5xz3nr4p">
        <h1 className="font-display text-5xl font-medium leading-tight md:text-6xl" data-id="element-135" data-mp="d9fh3la1kfmz">
          Cette page arrive bientôt.
        </h1>
        <p className="mt-5 max-w-lg text-lg text-ink-soft" data-id="element-136" data-mp="n11xrx55f6x4">
          Elle est en cours d’écriture. En attendant, retrouvez l’essentiel sur la page d’accueil.
        </p>
        <Link to="/" className="mt-10 inline-flex w-fit items-center gap-2 text-sm font-medium text-wood transition-colors duration-150 hover:text-wood-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-137" data-mp="i2qn5k714sdu">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="12535o66okdzc" />
          Retour à l’accueil
        </Link>
      </main>
      <SiteFooter data-id="element-139" data-mp="1666mow0gsg25" />
    </div>;
}